// src/constants.js

export const SHEET_CONFIG = {
  // ── PURVIEW Projects (testing) ──
  MAIN_SHEET: '1WvfO6YtmzIwf4XVEjLI-3Xu38WM_xWgapCWGtAtIxbo',
  MAIN_SHEET_GID: '',

  TOTAL_ASSETS_SHEET: '1l7oU-BkleaN8Nldpbsl5WJK14mTjKVHt',
  TOTAL_ASSETS_SHEET_GID: '437782116',

  DOA_SHEET: '1y3VvRFSigDBo1Vkn8ijDJnEawBLCz9smlH1vvECzlJU',

  // Copper Cabling BOM Sheet
  CABLING_BOM_SHEET: '1_MmOmJPJjpCUKloKGCAv7QWgxwuSI6Jv',
  CABLING_BOM_SHEET_GID: '483970021',

  // Copper Cabling Progress Sheet
  CABLING_SHEET: '1i8h6x2QMAIvoUco4GfB5Z7SePenNSZWnDuScV2bABiM',
  CABLING_SHEET_GID: '0',

  // Fibre Cabling BOM Sheet
  FIBRE_CABLING_BOM_SHEET: '1Ot70ZDZbtz5S7uh2CjuGuzZiXQSl_97c',
  FIBRE_CABLING_BOM_SHEET_GID: '206010849',

  // Fibre Cabling Progress Sheet
  FIBRE_CABLING_SHEET: '1paWSXsGuI0uGwcCR_Pr0qFxOiaiYqFS6xTUhr-Y9TDU',
  FIBRE_CABLING_SHEET_GID: '0',

  REPORTS_SHEET: '1Fsm_WM3ObgfH3uP98JQy10RoHa-jlzQMNwrWEg54ztc',

  // ── EDF PURVIEW – CLIENT (active) ──
  // MAIN_SHEET: '1VGdU7RZiV2iihaqQoXqI4VCXFisGgzw6zbJJ5Ggbc9w',
  // MAIN_SHEET_GID: '1763023759',

  // // Only for Dashboard Total Assets card - EDF
  // TOTAL_ASSETS_SHEET: '12TdNzk6ku5GDjFLUBn-qxJA3Jbpc5U8l',
  // TOTAL_ASSETS_SHEET_GID: '964368019',

  // DOA_SHEET: '1hzvhWwZYWPudcRZ5bfFKthBnyBt5shnAEeJ73KYUodI',

  // // Copper Cabling BOM Sheet - copied from PURVIEW Projects because EDF was missing
  // CABLING_BOM_SHEET: '1_MmOmJPJjpCUKloKGCAv7QWgxwuSI6Jv',
  // CABLING_BOM_SHEET_GID: '483970021',

  // // Copper Cabling Progress Sheet - EDF
  // CABLING_SHEET: '10xVxQL3Vp-4t4Sx7Vzw1_xjem3GtkJDlVaPnBARF3Ic',
  // CABLING_SHEET_GID: '0',

  // // Fibre Cabling BOM Sheet - copied from PURVIEW Projects because EDF was missing
  // FIBRE_CABLING_BOM_SHEET: '1Ot70ZDZbtz5S7uh2CjuGuzZiXQSl_97c',
  // FIBRE_CABLING_BOM_SHEET_GID: '206010849',

  // // Fibre Cabling Progress Sheet - copied from PURVIEW Projects because EDF was missing
  // FIBRE_CABLING_SHEET: '1paWSXsGuI0uGwcCR_Pr0qFxOiaiYqFS6xTUhr-Y9TDU',
  // FIBRE_CABLING_SHEET_GID: '0',

  // REPORTS_SHEET: '1nRJVQ_BKLDHwO-0mZnvXa03LxmcaNXIppZ8RjX6vGYI',
  // REPORTS_SHEET_GID: '0',

  // REFRESH_INTERVAL_MS: 120000,

  // MAX_ACTIVITIES_DISPLAY: 20,
  // MAX_PRODUCTS_DISPLAY: 6,
};

export const getSheetEditUrl = (sheetId, gid = '') => {
  let url = `https://docs.google.com/spreadsheets/d/${sheetId}/edit`;

  if (gid !== null && gid !== undefined && gid !== '') {
    url += `?gid=${gid}`;
  }

  return url;
};

export const getSheetCsvUrl = (sheetId, { gid, bustCache = false } = {}) => {
  let url = `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv`;

  if (gid !== null && gid !== undefined && gid !== '') {
    url += `&gid=${gid}`;
  }

  if (bustCache) {
    url += `&t=${Date.now()}`;
  }

  return url;
};

export const STATUS_HEX = {
  success: '#16a34a',
  danger: '#dc2626',
  warning: '#d97706',
  slate: '#64748b',
};

export const COLORS = {
  bg: '#f5f7fb',
  surface: '#ffffff',
  navy: '#1a2c3e',
  heading: '#0f172a',
  text: '#2c3e50',
  textSecondary: '#6c7a89',
  muted: '#95a5a6',
  line: '#e8ecef',
  border: '#dfe4e8',

  success: '#27ae60',
  successLight: '#e8f8f0',
  danger: '#e74c3c',
  dangerLight: '#fdedeb',
  warning: '#f39c12',
  warningLight: '#fef5e7',
  info: '#3498db',

  blue: '#3498db',
  cyan: '#1abc9c',
  green: '#2ecc71',
  red: '#e74c3c',
  amber: '#f39c12',
  violet: '#9b59b6',
  slate: '#7f8c8d',
  orange: '#e67e22',
  pink: '#e84393',
  purple: '#9b59b6',

  gradientBlue: 'linear-gradient(135deg, #3498db, #2980b9)',
  gradientGreen: 'linear-gradient(135deg, #27ae60, #2ecc71)',
  gradientOrange: 'linear-gradient(135deg, #f39c12, #e67e22)',
  gradientRed: 'linear-gradient(135deg, #e74c3c, #c0392b)',
  gradientPurple: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
  gradientDark: 'linear-gradient(135deg, #2c3e50, #1a2c3e)',
};

export const PARAM_CATEGORIES = [
  {
    id: 'psuPass',
    title: 'PSU Stability',
    columnPattern: /^psu\s*status$/i,
  },
  {
    id: 'fanPass',
    title: 'Fan Stability',
    columnPattern: /^fan\s*operation$/i,
  },
  {
    id: 'airPass',
    title: 'Airflow Stability',
    columnPattern: /^air\s*flow$|^airflow$/i,
  },
  {
    id: 'ledPass',
    title: 'LED Stability',
    columnPattern: /^led\s*status$/i,
  },
];

export const DOA_PATTERNS = {
  audit: [
    /psu status audit/i,
    /fan operation audit/i,
    /airflow audit/i,
    /air flow audit/i,
    /led status audit/i,
  ],
  validValues: [
    'pass',
    'passed',
    'fail',
    'failed',
    'good',
    'bad',
    'ok',
    'not ok',
  ],
};

export const HEADER_PATTERNS = {
  groupBy: [
    /description/i,
    /product\s*id/i,
    /product\s*code/i,
    /asset\s*type/i,
    /equipment\s*type/i,
    /device\s*type/i,
    /category/i,
    /product/i,
    /equipment\s*group/i,
    /device\s*group/i,
    /equipment\s*name/i,
    /device\s*name/i,
    /item\s*name/i,
    /asset\s*name/i,
    /name/i,
  ],

  timestamp: /timestamp|time\s*stamp|updated\s*at|created\s*at|date|time/i,

  importantData:
    /product|item|asset|serial|condition|status|psu|fan|air\s*flow|airflow|led|barcode|scan|name|description|equipment|device|category|type|power|rail/i,
};

export const STATUS_VALUES = {
  positive: [
    'good',
    'ok',
    'yes',
    'scanned',
    'completed',
    'pass',
    'working',
    'available',
  ],
  negative: [
    'damage',
    'damaged',
    'bad',
    'no',
    'missing',
    'pending',
    'fail',
    'failed',
    'not ok',
    'not scanned',
  ],
};

export const DATE_PATTERNS = {
  iso: /^\d{4}-\d{2}-\d{2}$/,
  timestamp: /\d{4}-\d{2}-\d{2}/,
  usShort: /\d{1,2}\/\d{1,2}\/\d{2,4}/,
  time: /\d{1,2}:\d{2}(:\d{2})?\s*(AM|PM)?/i,
};

export const SCAN_PATTERNS = {
  userPrefix: /^User[A-Za-z0-9]+_/i,
  isoDateTime: /@\s*(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/,
  shortDateTime: /(\d{2})\/(\d{2})\s+(\d{2}:\d{2})\s*$/,
};

export const CABLING_HEADERS = {
  itemNo: /item\s*no/i,
  productCode: /product\s*code/i,
  dressedIn: /dressed\s*in/i,
  qty: /^qty$/i,
  roughedIn: /roughed\s*in/i,
};

// ============================================================
// SHARON S3 DIGITAL TWIN
// SINGLE SOURCE OF TRUTH
// ============================================================

export const S3_TWIN_CONFIG = Object.freeze({
  // Rack Elevation source
  RACK_SHEET_ID:
    '1y3VvRFSigDBo1Vkn8ijDJnEawBLCz9smlH1vvECzlJU',

  RACK_ELEVATION_GID:
    1210403851,

  // ACTIVE EDF DOA source
  DOA_SHEET_ID:
    '1hzvhWwZYWPudcRZ5bfFKthBnyBt5shnAEeJ73KYUodI',

  DOA_GID:
    113060777,

  DOA_SHEET_NAME:
    'DOA report',

  REFRESH_INTERVAL_MS:
    30 * 1000,

  EXPECTED_RACK_COUNT:
    52,

  MIN_HEALTHY_RACK_COUNT:
    40,
});